import { render, staticRenderFns } from "./singleLabel.vue?vue&type=template&id=4246ea58&scoped=true&"
import script from "./singleLabel.vue?vue&type=script&lang=js&"
export * from "./singleLabel.vue?vue&type=script&lang=js&"
import style0 from "./singleLabel.vue?vue&type=style&index=0&id=4246ea58&prod&lang=scss&scoped=true&"
import style1 from "./singleLabel.vue?vue&type=style&index=1&id=4246ea58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4246ea58",
  null
  
)

export default component.exports